<app-header></app-header>
<app-sidebar></app-sidebar>
<!-- <app-right-sidebar></app-right-sidebar> -->
<div [dir]="direction">
  <app-carousel-popup></app-carousel-popup>
  <router-outlet></router-outlet>
</div>
